// extracted by mini-css-extract-plugin
export default {"root":"IconCircleCheck_root__phYse"};